module.exports = __webpack_public_path__ + "static/media/th.2cd15b0f.svg";